/**
 * Mascot — picks the right asset by state.
 * Assets live in /assets/character/ and gracefully fall back to idle.
 * Supported states: idle | happy | celebrating | studying | playing_drums | sleeping
 */
import { useMemo } from "react";

const BASE = "/assets/character";

// Only `idle` has a provided asset today. Others resolve to idle until supplied.
const SRC_BY_STATE = {
  idle: `${BASE}/mascot-idle.png`,
  happy: `${BASE}/mascot-happy.png`,
  celebrating: `${BASE}/mascot-celebrating.png`,
  studying: `${BASE}/mascot-studying.png`,
  playing_drums: `${BASE}/mascot-playing_drums.png`,
  sleeping: `${BASE}/mascot-sleeping.png`,
  achievement: `${BASE}/mascot-achievement.png`,
};
const FALLBACK = `${BASE}/mascot-idle.png`;

export default function Mascot({ state = "idle", size = 160, className = "", testId = "mascot", animate = true }) {
  const src = useMemo(() => SRC_BY_STATE[state] || FALLBACK, [state]);
  return (
    <img
      data-testid={testId}
      data-mascot-state={state}
      src={src}
      onError={(e) => { if (e.currentTarget.src !== window.location.origin + FALLBACK) e.currentTarget.src = FALLBACK; }}
      alt="Mascot"
      draggable={false}
      style={{ width: size, height: "auto" }}
      className={`select-none pointer-events-none ${animate ? (state === "celebrating" || state === "achievement" ? "animate-jig" : state === "playing_drums" ? "animate-bob" : "animate-floaty") : ""} ${className}`}
    />
  );
}
